export default {
    loadEventParticipants: function (eventId, participants, fetchTime, categoryValues, categories, recommendedFilter) {
        return {
            type: 'EVENT_PARTICIPANTS_LOADED',
            eventId,
            participants,
            fetchTime,
            categoryValues,
            categories,
            recommendedFilter,
        };
    },
    updateParticipant: function (eventId, participant) {
        return {type: 'EVENT_PARTICIPANT_UPDATED', eventId, participant};
    },
    needsDisambiguation: function (eventId, matches) {
        return {type: 'EVENT_PARTICIPANTS_DISAMBIGUATION', eventId, matches};
    },
    filterByText: function (eventId, text) {
        return {type: 'EVENT_PARTICIPANTS_FILTER_BY_TEXT', eventId, text};
    },
    filterByCategories: function (eventId, catFilter) {
        return {type: 'EVENT_PARTICIPANTS_FILTER_BY_CATEGORIES', eventId, catFilter};
    },
    setFilterParams: function (eventId, filterParams) {
        return {type: 'EVENT_PARTICIPANTS_FILTER_SET', eventId, filterParams};
    },
    addCategoryFilter: function (eventId, catName, optionValue) {
        return {type: 'EVENT_PARTICIPANTS_FILTER_ADD_CATEGORY_VALUE', eventId, catName, optionValue};
    },
    removeCategoryFilter: function (eventId, catName, optionValue) {
        return {type: 'EVENT_PARTICIPANTS_FILTER_REMOVE_CATEGORY_VALUE', eventId, catName, optionValue};
    },
    applyRecommendedFilter: function (eventId) {
        return {type: 'EVENT_PARTICIPANTS_USE_RECOMMENDED', eventId};
    },
    updateCategories: function (eventId, categories) {
        return {type: 'EVENT_PARTICIPANTS_UPDATE_CATEGORIES', eventId, categories};
    },
    poked: function (eventId, participantId) {
        return {type: 'EVENT_PARTICIPANT_POKED', eventId, participantId};
    },
    updateFavorite: function (eventId, userId, participantId, isFavorite) {
        return [
            eventId && participantId
                ? this.updateParticipant(eventId, {
                      participant_id: participantId,
                      is_favorite: isFavorite,
                  })
                : null,
            userId
                ? {
                      type: 'UPDATE_USER',
                      userId,
                      user: {
                          is_favorite: isFavorite,
                      },
                  }
                : null,
        ].filter(i => i);
    },
};
